"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targetIsInvalid = exports.reorderItems = exports.isItemData = exports.idleState = exports.getItemData = exports.draggingState = void 0;
var itemKey = Symbol('item');

var isItemData = exports.isItemData = function isItemData(data) {
  return data[itemKey] === true;
};

var getItemData = exports.getItemData = function getItemData(_ref) {
  var _ref2;

  var item = _ref.item,
      index = _ref.index,
      instanceId = _ref.instanceId;
  return _ref2 = {}, _ref2[itemKey] = true, _ref2.item = item, _ref2.index = index, _ref2.instanceId = instanceId, _ref2;
};

var draggingState = exports.draggingState = {
  type: 'dragging'
};
var idleState = exports.idleState = {
  type: 'idle'
};

var reorderItems = exports.reorderItems = function reorderItems(questionList, oldIndex, newIndex, item) {
  // if the difference between the two indexes is 1, we only need to swap two items
  var itemToMove = item;
  var itemToReplace = questionList[newIndex];
  var newPosition = itemToReplace.position;

  if (Math.abs(oldIndex - newIndex) === 1) {
    var oldPosition = itemToMove.position;
    itemToReplace.position = oldPosition;
    itemToMove.position = newPosition;
    return [itemToMove, itemToReplace];
  } // otherwise we need to reposition all items between the two indexes


  var itemsToReorder = questionList.slice(Math.min(oldIndex, newIndex), Math.max(oldIndex, newIndex) + 1);
  var newItemPositions = itemsToReorder.map(function (question) {
    var questionToMove = question;

    if (questionToMove.id === itemToMove.id) {
      // if it's the item we moved, we set the new position value based off what was previously there
      questionToMove.position = newPosition;
    } else {
      // otherwise, if the old index is bigger than the new index, the item moved UP, so everything else moves down and vice-versa
      questionToMove.position = oldIndex > newIndex ? questionToMove.position + 1 : questionToMove.position - 1;
    }

    return questionToMove;
  });
  return newItemPositions;
};

var targetIsInvalid = exports.targetIsInvalid = function targetIsInvalid(location, source, items) {
  var target = location.current.dropTargets[0];

  if (!target) {
    return true;
  }

  var sourceData = source.data;
  var targetData = target.data;

  if (!isItemData(sourceData) || !isItemData(targetData)) {
    return true;
  }

  var indexOfTarget = items.findIndex(function (item) {
    return item.id === targetData.item.id;
  });

  if (indexOfTarget < 0 || indexOfTarget === sourceData.index) {
    return true;
  }

  return false;
};